(function () {
    'use strict';

    angular.module("imApp").factory("poFinishCompListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1298,
                    parameters: parms || {}
                });
            },
            listFinishedComponents: function (parms) {
                return $ihttp.post({
                    method: 166,
                    parameters: parms || {}
                });
            },
            scanComponent: function (setting) {
                return $ihttp.post({
                    method: 171,
                    parameters: setting
                });
            },
            finishProductionOrder: function (setting) {
                return $ihttp.post({
                    method: 197,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
